import React, { FC } from 'react';
import styled from 'styled-components';

import { ReactComponent as ShovelLogo } from '../../assets/shovel-logo.svg';
import { EMAIL, LOGIN_AS_ADMIN, PASSWORD } from '../../utils/constants/labels';
import colors from '../../utils/colors';
import { ExtraLargeText } from '../../utils/typography';
import { Button, Form, Input } from 'antd';
import { api } from '../../api/api';
import storage from '../../utils/storage';
import { handleErrorResponse, removeAccessToken, setAccessToken } from '../../api/network';
import { DASHBOARD, SUBSCRIBED_USERS } from '../../utils/constants/routes';
import { useHistory } from 'react-router';

type Props = {};

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 20 }
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 20 }
};

const Login: FC<Props> = () => {
  const history = useHistory();

  return (
    <Container>
      <Logo />
      <Title>{LOGIN_AS_ADMIN}</Title>
      <Form
        {...layout}
        style={{ width: '300px' }}
        initialValues={{ email: '', password: '' }}
        onFinish={async values => {
          removeAccessToken();
          storage.removeAccessToken();
          // @ts-ignore
          const response = await api.login(values);

          if (!response.ok) {
            handleErrorResponse(response, history, true);
            return;
          }

          const { accessToken, refreshToken, ...user } = response.data;

          const oldUserId = storage.getUserId();

          if (oldUserId !== user.id) {
            storage.removeUserId();
            storage.removeAccessToken();
          }

          storage.setUserId(user.id);
          storage.setAccessToken(accessToken);

          setAccessToken(accessToken);

          history.push(`${DASHBOARD}${SUBSCRIBED_USERS}`);
        }}
      >
        <Form.Item name="email" label={EMAIL} rules={[{ required: true, type: 'email' }]}>
          <Input />
        </Form.Item>
        <Form.Item name="password" label={PASSWORD} rules={[{ required: true }]}>
          <Input type="password" />
        </Form.Item>
        <Form.Item {...tailLayout}>
          <Button type="primary" htmlType="submit">
            Log in
          </Button>
        </Form.Item>
      </Form>
    </Container>
  );
};

export default Login;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: ${colors.white};
  align-items: center;
  justify-content: center;
`;

const Logo = styled(ShovelLogo)`
  height: 50px;
  width: 50px;
`;

const Title = styled(ExtraLargeText)`
  margin: 20px 0px 30px 0;
  text-align: center;
`;
